const AUTO_APPLY_MODES = new Set(['ghost-write', 'disabled', 'embed']);

export function isAutoAcceptMode(mode: string): boolean {
  return AUTO_APPLY_MODES.has(mode);
}

/**
 * Auto-applied edits are recorded separately from user-confirmed ones: folding
 * them together would report an acceptance rate for decisions no user made.
 */
export function dispositionForAccept(mode: string): string {
  return isAutoAcceptMode(mode) ? 'auto_accepted' : 'accepted';
}
